module.exports = __webpack_public_path__ + "img/loading.be12450a.gif";